import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcAutorefund(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.493 13.013.374 1.483h1.756l.279-1.13q.184-.73.269-.993.091-.27.333-.508.248-.246.673-.246.432 0 .673.246.247.237.347.524.099.279.276.976l.28 1.131h1.765l.378-1.483q.127-.54.205-.78.079-.245.262-.426.184-.188.532-.188a.79.79 0 0 1 .602.279.94.94 0 0 1 .255.656q0 .344-.22 1.04l-.265.902h.912a.759.759 0 1 1 0 1.518h-1.36l-.866 2.942q-.206.68-.32.984a1.44 1.44 0 0 1-.36.54q-.241.239-.666.238-.44 0-.695-.254a1.6 1.6 0 0 1-.368-.623q-.12-.369-.262-.959l-.727-2.868h-.744l-.704 2.868q-.212.91-.46 1.377-.249.46-.872.46a1 1 0 0 1-.545-.148 1.1 1.1 0 0 1-.368-.402q-.15-.27-.263-.631l-.177-.582-.859-2.942H2.196a.759.759 0 1 1 0-1.518h.924l-.263-.901q-.234-.754-.234-1.042 0-.36.248-.647a.78.78 0 0 1 .61-.287q.48 0 .651.32.17.31.361 1.074m1.297 5-.504-2h.998zm4.867 0-.494-2h1.003z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.551 21.647a.5.5 0 0 1-.55-.55l.413-3.887a.5.5 0 0 1 .85-.301l3.475 3.474a.5.5 0 0 1-.301.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 0 0-7.785 5.512.75.75 0 1 1-1.415-.497A9.75 9.75 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a9.74 9.74 0 0 1-4.732 8.361.75.75 0 0 1-.773-1.285A8.25 8.25 0 0 0 12 3.75",
    clipRule: "evenodd"
  }));
}
var IcAutorefund = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAutorefund));

export { IcAutorefund as I };
